import { JiraIssueCollector } from '../models/JiraIssueCollector';

export class JiraIssueCollectorMapper {
  mapGQLModel(data: any) {
    return new JiraIssueCollector(data.issueCollectorCode);
  }
}
